import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import {IAccountsPayable, IAccountsPayableDetail, IBaseResponse} from '@nkr/models/index';
import { IApplicationState, AppActionCreators, ReportActionCreators, IAccountsPayableReportResponse, IApDetailReportResponse } from '@nkr/store/index';
import { ColumnApi, GridApi, GridReadyEvent, ProcessCellForExportParams, ExcelExportParams, ColumnWidthCallbackParams } from 'ag-grid-community';
import { Button, ButtonToolbar, ToggleButtonGroup, ToggleButton, } from 'react-bootstrap';
import ArApNav from '../ar-ap-nav';
import { RouteComponentProps } from 'react-router';
import ApDetail from './detail';
import Grid from './grid';
import {toast} from "react-toastify";
import { downloadFile } from '@nkr/services/download-file';
import { AsOfExportModal } from '../as-of-export-modal';

interface IOwnProps extends RouteComponentProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAccountsPayable: () => Promise<IAccountsPayableReportResponse>,
    getApDetails: (centerId: number) => Promise<IApDetailReportResponse>,
    payCcbItems: ( achConfirmation : string, amountPaid : number, lineItems : IAccountsPayableDetail[] ) => Promise<IBaseResponse>,
    getAsOfReport: (date: string) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: IAccountsPayable[],
    radioFilter: number,
    centerId: number,
    showAsOfModal: boolean,
    details: {
        show: boolean,
        centerSummary: IAccountsPayable,
        list: IAccountsPayableDetail[]
    }
}

class AccountsPayable extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        centerId: 0,
        radioFilter: 1,
        showAsOfModal: false,
        details: {
            show: false,
            centerSummary: null,
            list: []
        }
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null; 

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.columnApi.applyColumnState({
            state: [
                { colId: 'centerHasLatePaymentsInLastYear', sort: 'asc' }
            ]
        });
    }

    // onFirstDataRendered = () => {
    //     this.gridApi.sizeColumnsToFit();
    // }

    // onRowDataChanged = (e: RowDataChangedEvent) => {
    //     e.api.sizeColumnsToFit();
    // }

    componentDidMount = () => {
        this.getData();
    }

    showModal = (centerId: number) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getApDetails(centerId).then((response) => {
                if (response.data.success) {
                    let list = response.data.results;

                    let centerSummary = this.state.data.find(x => x.centerId == centerId);

                    this.setState({
                        details: {
                            show: true,
                            centerSummary,
                            list
                        },
                    }, () => {
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });

        return true;
    }

    handleCloseDetail = () => {
        this.setState({
            details: {
                show: false,
                centerSummary: null,
                list: []
            },
        });
    }

    handleDetailChecked = ( detail : IAccountsPayableDetail ) => {
        var detailsClone  = _.cloneDeep(this.state.details);
        var newList      = detailsClone.list.map((item, index) => {
            if( item.donorAlias == detail.donorAlias && item.billingType == detail.billingType ) {
                item.isChecked  = !detail.isChecked;
            }
            return item;
        });

        this.setState({
            details: {
                show: detailsClone.show,
                centerSummary: detailsClone.centerSummary,
                list: newList
            }
        });
    }

    handleMarkPaid = ( achConfirmation : string, amountPaid : number, lineItems : IAccountsPayableDetail[] ) => {
        this.props.showLoading('Submitting Payments').then(() => {
            this.props
                .payCcbItems( achConfirmation, amountPaid, lineItems )
                .then( (response) => {
                    this.props.hideLoading();

                    if( response.data.success ) {
                        toast.success("Payments Submitted Successfully");
                        this.handleCloseDetail();
                        this.getData();
                    }
                    else {
                        toast.error(response.data.message, { autoClose: 5000 });
                    }
                })
            ;
        });
    };

    handleCheckPayNow = () => {
        let detailsClone    = _.cloneDeep(this.state.details);
        let newList         = detailsClone.list.map((item, index) => {
            let payAfter        = this.state.details.centerSummary.payAfterDayNumber;
            item.isChecked      = payAfter > 0 && item.daysOutstanding >= payAfter;
            return item;
        });

        this.setState({
            details: {
                show: detailsClone.show,
                centerSummary: detailsClone.centerSummary,
                list: newList
            }
        });
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getAccountsPayable().then((response) => {
                if (response.data.success) {
                    let list = response.data.results;

                    this.setState({
                        data: list
                    }, () => {
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    };

    // getTotals = (filteredList: IAccountsPayable[]): IAccountsPayable[] => {
    //     let totals = {
    //         centerId: 0,
    //         centerAlias: '',
    //         pending0To45: 0,
    //         pending46To60: 0,
    //         pending61To90: 0,
    //         pending91To120: 0,
    //         pending121To150: 0,
    //         pendingOver150: 0,
    //         totalPending: 0,
    //         payNow: 0,
    //         centerHasAchOnFile: false,
    //         centerHasOutstandingDelinquency: undefined,
    //         centerHasLatePaymentsInLastYear: false,
    //     };

    //     filteredList.forEach(item => {
    //         totals.pending0To45 += item.pending0To45;
    //         totals.pending46To60 += item.pending46To60;
    //         totals.pending61To90 += item.pending61To90;
    //         totals.pending91To120 += item.pending91To120;
    //         totals.pending121To150 += item.pending121To150;
    //         totals.pendingOver150 += item.pendingOver150;
    //         totals.totalPending += item.totalPending;
    //         totals.payNow += item.payNow;
    //     });

    //     return [totals];
    // }

    // createTopData = (): IAccountsPayableDetail[] => {
    //     let result = {
    //         amount: 0,
    //         billingType: '',
    //         billableCenterAlias: '',
    //         billableCenterId: 0,
    //         invoiceDate: '',
    //         daysOutstanding: 0,
    //         payableCenterId: 0,
    //         payableCenterAlias: '',
    //         isPaid: false
    //     };

    //     //get transportCost Total
    //     result.amount = this.state.details.list.reduce((a, v) => a = a + v.amount, 0);

    //     return [result];
    // }

    handleRadioFilterChange = (radioType: number) => {
        this.setState({
            radioFilter: radioType
        });
    }

    getFilteredData = () => {
        //0=>all, 1=>pay now, 2=> no ach, 3=>on time, 4=>late, 5=>delinquent
        var withAchOnly = [1].includes(this.state.radioFilter);
        var noAchOnly = [2].includes(this.state.radioFilter);
        var onTimeOnly = [3].includes(this.state.radioFilter);
        var lateOnly = [4].includes(this.state.radioFilter);
        var delinqOnly = [5].includes(this.state.radioFilter);
        var payNow = [1].includes(this.state.radioFilter);

        var filteredList = _.cloneDeep(this.state.data);

        if (withAchOnly) {
            filteredList = filteredList.filter(x => { return x.centerHasAchOnFile ? x : null });
        }
        else if (noAchOnly) {
            filteredList = filteredList.filter(x => { return x.centerHasAchOnFile ? null : x });
        }

        if (onTimeOnly) {
            filteredList = filteredList.filter(x => { return !x.centerHasOutstandingDelinquency && !x.centerHasLatePaymentsInLastYear ? x : null });
        }
        else if (lateOnly) {
            filteredList = filteredList.filter(x => { return !x.centerHasOutstandingDelinquency && x.centerHasLatePaymentsInLastYear ? x : null });
        }
        else if (delinqOnly) {
            filteredList = filteredList.filter(x => { return x.centerHasOutstandingDelinquency ? x : null });
        }

        if (payNow) {
            filteredList = filteredList.filter(x => {
                if (x.centerHasOutstandingDelinquency || !x.centerHasAchOnFile) { return null; }
               
                x.pending91To120 = ((x.centerHasLatePaymentsInLastYear ? 0 : x.pending91To120) || 0);
                x.pending121To150 = ((x.centerHasLatePaymentsInLastYear ? 0 : x.pending121To150) || 0);

                var due = x.pending91To120 + x.pending121To150 + x.pendingOver150;

                return due > 0 ? x : null
            });
        }
        return filteredList;
    }

    handleExport = () => {
        let keys = this.gridColumnApi.getAllColumns().filter(x => x.getColId() != 'details').map(x => x.getColId());

        let params: ExcelExportParams = {
            columnGroups: true,
            fileName: `ccb-accounts-payable-aging.xlsx`,
            columnKeys: keys,
            columnWidth: (params: ColumnWidthCallbackParams) => {
                let colDef = params.column.getColDef();
                return colDef.width;
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.colId == 'centerAlias') {
                    if (params.node.data.centerAlias == '') {
                        return 'Totals';
                    }
                }

                if (colDef.colId == 'centerHasAchOnFile') {
                    if (params.node.data.centerAlias != '') {
                        return params.value ? 'Y' : 'N';
                    } else {
                        return '';
                    }
                }

                if (colDef.colId == 'rank') {
                    if (params.node.data.centerAlias != '') {
                        return params.value;
                    } else {
                        return '';
                    }
                }

                return params.value;
            },
        };

        this.gridApi.exportDataAsExcel(params);
    }

    handleExportAsOf = (date: string) => {
        this.setState({ showAsOfModal: false });

        this.props.showLoading('Generating report, one moment please...').then(() => {
            this.props.getAsOfReport(date)
                .then((response) => {
                    downloadFile(response.data, `ccb-payable-as-of_${date}.csv`, 'text/csv');
                })
                .finally(() => this.props.hideLoading());
        });
    }

    render = () => {
        const filteredData = this.getFilteredData();

        return (
            <>
                <div className='container-fluid'>
                    <ArApNav href={this.props.location.pathname} />

                    <div style={{ padding: 10, borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                        <div className='well well-sm' style={{ marginBottom: 5, display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filters:</div>
                                <ButtonToolbar>
                                    <ToggleButtonGroup type='radio' name='options' defaultValue={this.state.radioFilter}>
                                        <ToggleButton onClick={() => this.handleRadioFilterChange(1)} value={1}>Pay</ToggleButton>
                                        <ToggleButton onClick={() => this.handleRadioFilterChange(0)} value={0}>All</ToggleButton>                                     
                                        <ToggleButton onClick={() => this.handleRadioFilterChange(3)} value={3}>On Time</ToggleButton>
                                        <ToggleButton onClick={() => this.handleRadioFilterChange(4)} value={4}>Late</ToggleButton>
                                        <ToggleButton onClick={() => this.handleRadioFilterChange(5)} value={5}>Delinquent</ToggleButton>
                                    </ToggleButtonGroup>
                                </ButtonToolbar>
                            </div>
                            <div>
                                <Button onClick={this.handleExport}>Export to Excel</Button>
                                <Button onClick={() => this.setState({ showAsOfModal: true })} style={{ marginLeft: 8 }}>Export As-Of</Button>
                            </div>
                        </div>

                        <Grid data={filteredData} onGridReady={this.onGridReady} onShowDetail={this.showModal} />
                    </div>
                </div>

                <ApDetail
                    show={this.state.details.show}
                    centerSummary={this.state.details.centerSummary}
                    data={this.state.details.list}
                    onClose={this.handleCloseDetail}
                    onDetailChecked={this.handleDetailChecked}
                    onMarkPaid={this.handleMarkPaid}
                    onCheckPayNow={this.handleCheckPayNow}
                />

                <AsOfExportModal
                    show={this.state.showAsOfModal}
                    onClose={() => this.setState({ showAsOfModal: false })}
                    onExport={this.handleExportAsOf} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {}
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAccountsPayable: () => {
            return dispatch(ReportActionCreators.getAccountsPayable());
        },
        getApDetails: (centerId) => {
            return dispatch(ReportActionCreators.getApDetailsByCenterId(centerId));
        },
        payCcbItems: ( achConfirmation : string, amountPaid : number, lineItems : IAccountsPayableDetail[] ) => {
            return dispatch(ReportActionCreators.payCcbItems(achConfirmation, amountPaid, lineItems));
        },
        getAsOfReport: (date: string) => {
            return dispatch(ReportActionCreators.getBillingAsOfReport('accounts-payable', date));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AccountsPayable);